import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";

class BottomBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: [
        {
          id: 1,
          name: "Home",
          links: "/",
        },
        {
          id: 2,
          name: "CityX App",
          links: "/apps/cityx-app",
        },
        /*
        {
          id: 3,
          name: "CityX Tour&Pass",
          links: "/apps/cityx-tour-pass",
        },
        */
        {
          id: 4,
          name: "Sportter",
          links: "/apps/sportter",
        },
        {
          id: 5,
          name: "Novosti",
          links: "/news-list",
        },
        {
          id: 6,
          name: "Karijere",
          links: "/about/carees",
        },
        {
          id: 7,
          name: "Contact",
          links: "/contact",
        },
      ],
    };
  }

  render() {
    return (
      <div id="bottom" className="clearfix has-spacer">
        <div id="bottom-bar-inner" className="container">
          <div className="bottom-bar-inner-wrap">
            <div className="bottom-bar-content">
              <div id="copyright">
                <span className="text">
                  &copy; 2021. CityX Apps d.o.o., sva prava su pridržana.
                  <br />
                  &reg; CityX je registrirani trademark CityX Apps
                </span>
              </div>
            </div>
            {/* /.bottom-bar-content */}
            <div className="bottom-bar-menu">
              <ul className="bottom-nav">
                {this.state.menus.map((data) => (
                  <li
                    className={
                      data.name === this.props.data.names
                        ? "menu-item current-menu-item"
                        : "menu-item"
                    }
                    key={data.id}
                  >
                    <a href={data.links}> {data.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BottomBar);
